import Bowser from 'bowser';

export default function isBrowserSupported (supportedBrowsers) {
  const browser = Bowser.getParser(window.navigator.userAgent, true);
  return browser.satisfies(supportedBrowsers);
}
